export const currency = "Dhs";
export const APP_URL = process.env.REACT_APP_PUBLIC_URL;
export const API_URL = process.env.REACT_APP_API_URL;
